"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.resourceOpsToChangesets = void 0;
const store_1 = require("../exports/store");
const types_1 = require("../types");
const utils_1 = require("../utils");
function resourceOpsToChangesets(resourceOpsCollects, state) {
    const changesetMap = new Map();
    resourceOpsCollects.forEach(collect => {
        var _a, _b;
        const { resourceId, resourceType, operations } = collect;
        // One datasheet, one changeset
        let changeset = changesetMap.get(resourceId);
        if (!changeset) {
            let revision;
            if (resourceType == types_1.ResourceType.Dashboard) {
                revision = (_a = store_1.Selectors.getDashboard(state, resourceId)) === null || _a === void 0 ? void 0 : _a.revision;
            }
            else {
                revision = (_b = store_1.Selectors.getDatasheet(state, resourceId)) === null || _b === void 0 ? void 0 : _b.revision;
            }
            changesetMap.set(resourceId, (changeset = {
                baseRevision: revision,
                messageId: (0, utils_1.generateRandomString)(),
                resourceId,
                resourceType,
                operations,
            }));
        }
        else {
            changeset.operations.push(...operations);
        }
    });
    return [...changesetMap.values()];
}
exports.resourceOpsToChangesets = resourceOpsToChangesets;
//# sourceMappingURL=changesets.js.map